import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { Flex, Text } from "sprout-ui-primitives";
import { Link } from "react-router-dom";
import { anchorStyles } from "./styles";
const StyledA = styled("a")`
  ${anchorStyles};
`;
const LandingFooter = ()=>{
    return /*#__PURE__*/ _jsxs(Flex, {
        flexDirection: "column",
        alignItems: "center",
        as: "footer",
        mt: "240px",
        px: 7,
        children: [
            /*#__PURE__*/ _jsxs(Text, {
                as: "p",
                fontSize: [
                    3,
                    null,
                    4
                ],
                fontWeight: "medium",
                textAlign: "center",
                children: [
                    `Questions? Email `,
                    /*#__PURE__*/ _jsx(StyledA, {
                        href: "mailto:support@sprout.io",
                        children: "support@sprout.io"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Text, {
                as: "p",
                fontSize: [
                    2,
                    null,
                    3
                ],
                my: 11,
                textAlign: "center",
                children: [
                    "Sprout \xa9 ",
                    new Date().getFullYear(),
                    " | ",
                    /*#__PURE__*/ _jsx(Link, {
                        to: "/terms",
                        children: "Terms"
                    }),
                    " & ",
                    /*#__PURE__*/ _jsx(Link, {
                        to: "/privacy",
                        children: "Privacy"
                    })
                ]
            })
        ]
    });
};
export default LandingFooter;
